import { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { auth } from "@/lib/firebase";

const AuthContext = createContext(null);

// Real Firebase Authentication (email/password) against the shared
// brugo-core-97965 project. Roles come from Firebase Auth custom claims.
// No localStorage password gate, no mock users.
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!auth) { setReady(true); return; }
    const unsub = onAuthStateChanged(auth, async (fbUser) => {
      if (fbUser) {
        let role = null;
        try {
          const token = await fbUser.getIdTokenResult();
          role = token.claims.role || null;
        } catch (e) { /* claims unavailable */ }
        setUser({
          uid: fbUser.uid,
          email: fbUser.email,
          name: fbUser.displayName || (fbUser.email ? fbUser.email.split("@")[0] : "User"),
          role,
        });
      } else {
        setUser(null);
      }
      setReady(true);
    });
    return () => unsub();
  }, []);

  const login = async (email, password) => {
    if (!auth) throw new Error("Firebase is not configured");
    const cred = await signInWithEmailAndPassword(auth, email.trim(), password);
    return cred.user;
  };

  const logout = () => auth && signOut(auth);

  return (
    <AuthContext.Provider value={{ user, ready, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
